import DsCustomer from './src/index';

/* istanbul ignore next */
DsCustomer.install = function(Vue) {
    Vue.component(DsCustomer.name, DsCustomer);
};

export default DsCustomer;
